import { SearchIcon } from "lucide-react";
import * as React from "react";
import { useForm } from "react-hook-form";

interface FormInputs {
  query: string;
}

interface Props {
  setQuery: (query: string) => void;
  query?: string;
  reset: () => void;
  isFetching: boolean;
}

export const SnapshotCollectionsOutcomesListInput: React.FC<Props> = ({ isFetching, query, setQuery, reset }) => {
  const methods = useForm<FormInputs>();
  const { reset: resetForm } = methods;

  React.useEffect(() => {
    if (!query) {
      resetForm({ query: "" });
    }
  }, [query, resetForm]);

  const handleReset = () => {
    reset();
    resetForm({ query: "" });
  };

  const onSearch = async (payload: FormInputs) => {
    if (!payload.query) {
      return;
    }
    setQuery(payload.query);
  };

  return (
    <form onSubmit={methods.handleSubmit(onSearch)} className="mb-4 flex flex-1 items-center">
      <div className="relative flex-grow">
        <input
          type="text"
          {...methods.register("query")}
          placeholder="Search in SnapShots"
          className="w-full rounded-md border border-gray-300 py-2 pl-10 pr-4 focus:border-blue-500 focus:outline-none"
        />
        <SearchIcon className="absolute left-3 top-1/2 h-5 w-5 -translate-y-1/2 text-gray-400" />
      </div>
      <button
        type="submit"
        disabled={!!query && isFetching}
        onClick={methods.handleSubmit(onSearch)}
        className="ml-2 rounded-md bg-coral px-4 py-2 text-white focus:outline-none focus:ring-2 focus:ring-blue-900 focus:ring-opacity-50"
      >
        {query && isFetching ? "Searching..." : "Search"}
      </button>
      {query && (
        <button
          type="button"
          onClick={handleReset}
          className="ml-2 rounded-md bg-gray-300 px-4 py-2 text-gray-700 hover:bg-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-300 focus:ring-opacity-50"
        >
          Clear
        </button>
      )}
    </form>
  );
};
